import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "base-signature" }
const _hoisted_2 = {
  key: 0,
  class: "signature"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "empty-signature"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 2,
  class: "actions"
}
const _hoisted_7 = ["width"]

import { ref, nextTick } from "vue";
import { useI18n } from "vue-i18n";

import { cropSignature } from "@/common/utils/image";

import { svgIcon, baseModal } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-signature',
  props: {
    signature: { default: null },
    width: { default: "40rem" },
    showActions: { type: Boolean, default: false },
    showDel: { type: Boolean, default: false }
  },
  emits: ["save", "refresh", "del"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "f97b7662": (_ctx.width)
}))

const { t } = useI18n();

const emit = __emit;

const props = __props;

const boxSinature = ref<any>(null);
const canvas = ref<any>(null);
const ctx = ref<any>(null);

const drawing = ref(false);
const showModal = ref(false);

function startDrawing(event: any) {
  drawing.value = true;
  const rect = canvas.value.getBoundingClientRect();
  ctx.value.beginPath();
  ctx.value.moveTo(event.clientX - rect.left, event.clientY - rect.top);
}

function stopDrawing() {
  drawing.value = false;
}

function draw(event: any) {
  if (drawing.value && canvas.value && ctx.value) {
    const rect = canvas.value.getBoundingClientRect();
    ctx.value.lineTo(event.clientX - rect.left, event.clientY - rect.top);
    ctx.value.stroke();
  }
}

function clean() {
  if (ctx.value && canvas.value) {
    ctx.value.clearRect(0, 0, canvas.value.width, canvas.value.height);
  }
}

function save() {
  if (canvas.value) {
    emit("save", cropSignature(ctx.value, canvas.value));
    showModal.value = false;
    clean();
  }
}

function del() {
  emit("del");
}

async function openSignature() {
  showModal.value = true;
  await nextTick();

  ctx.value = canvas.value.getContext("2d");
  ctx.value.lineWidth = 2;
  ctx.value.lineCap = "round";
  ctx.value.strokeStyle = "black";
}

function closeSignature() {
  showModal.value = false;
  clean();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (props.signature)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: props.signature
          }, null, 8, _hoisted_3)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "signature",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openSignature()))
          }, [
            _createElementVNode("img", {
              src: require('@/assets/images/signature.png')
            }, null, 8, _hoisted_5)
          ])
        ])),
    (props.showActions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (props.signature)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-default btn-sm",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (openSignature()))
              }, [
                _createVNode(_unref(svgIcon), {
                  icon: "refresh",
                  size: "1.5rem"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.refresh")), 1)
              ]))
            : _createCommentVNode("", true),
          (props.showDel)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-danger btn-sm",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (del()))
              }, [
                _createVNode(_unref(svgIcon), {
                  icon: "trash",
                  size: "1.5rem"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.delete")), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(baseModal), {
      show: showModal.value,
      title: _unref(t)('common.labels.signature').toUpperCase()
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", {
          ref_key: "boxSinature",
          ref: boxSinature,
          class: "box-signature"
        }, [
          (boxSinature.value)
            ? (_openBlock(), _createElementBlock("canvas", {
                key: 0,
                ref_key: "canvas",
                ref: canvas,
                onMousedown: startDrawing,
                onMouseup: stopDrawing,
                onMousemove: draw,
                onMouseleave: stopDrawing,
                width: boxSinature.value.offsetWidth,
                height: "200",
                style: {"border":"1px solid #000000"}
              }, null, 40, _hoisted_7))
            : _createCommentVNode("", true)
        ], 512)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("button", {
          class: "btn btn-primary btn-md",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (save()))
        }, _toDisplayString(_unref(t)("common.labels.save")), 1),
        _createElementVNode("button", {
          class: "btn btn-defatul btn-md",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (clean()))
        }, _toDisplayString(_unref(t)("common.labels.clean")), 1),
        _createElementVNode("button", {
          class: "btn btn-default btn-md",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (closeSignature()))
        }, _toDisplayString(_unref(t)("common.labels.close")), 1)
      ]),
      _: 1
    }, 8, ["show", "title"])
  ]))
}
}

})